export default __webpack_public_path__ + "static/media/spinner.09d7e494.gif";